import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export const SUPPORTED_LANGUAGES = ['en', 'de', 'ar', 'es']
const localeLoaders = {
    en: () => import('./translations/generated/en.json'),
    de: () => import('./translations/generated/de.json'),
    ar: () => import('./translations/generated/ar.json'),
    es: () => import('./translations/generated/es.json'),
}

export function normalizeLanguage(language) {
    const code = String(language || '').toLowerCase().split(/[-_]/)[0]
    return SUPPORTED_LANGUAGES.includes(code) ? code : 'en'
}

function initialLanguage() {
    try {
        const query = new URLSearchParams(window.location.search)
        const cookie = document.cookie.split('; ').find(value => value.startsWith('i18next='))
        return normalizeLanguage(query.get('lng') || query.get('locale') ||
            (cookie && decodeURIComponent(cookie.slice(8))) || localStorage.getItem('locale'))
    } catch {
        return 'en'
    }
}

// Explicit imports let the bundler emit one chunk per language. Loading a new
// language uses i18next's normal async lifecycle, including Suspense on a switch.
const localeBackend = {
    type: 'backend',
    init() {},
    read(language, namespace, callback) {
        localeLoaders[normalizeLanguage(language)]().then(
            module => callback(null, module.default),
            error => callback(error, false)
        )
    },
}

const changeLanguage = i18n.changeLanguage.bind(i18n)
i18n.changeLanguage = (language, callback) => changeLanguage(normalizeLanguage(language), callback)

export const i18nReady = i18n.use(localeBackend).use(initReactI18next).init({
    lng: initialLanguage(),
    supportedLngs: SUPPORTED_LANGUAGES,
    load: 'languageOnly',
    maxRetries: 0, // Failed module imports are cached by browsers; use English fallback immediately.
    // Dictionaries must be complete: an eager fallback downloads a second locale.
    fallbackLng: false,
    interpolation: { escapeValue: false },
}).then(async () => {
    if (!i18n.hasResourceBundle(i18n.language, 'translation')) {
        await i18n.changeLanguage('en')
        if (!i18n.hasResourceBundle('en', 'translation')) throw new Error('Translations could not be loaded')
    }
    return i18n
})

export default i18n
